import styled from "styled-components";
import { colors } from "../../consts";

export const ChangesNotSavedOptions = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
`;

export const ChangesNotSavedOption = styled.li`
  color: ${colors.RAISIN_70};
  margin-bottom: 10px;
`;
